// ambassador-application.service.ts

import { supabase } from "./supabase";
import { AmbassadorApplicationData } from "../types/ambassador.types";

class AmbassadorApplicationService {
  async submitApplication(userId: string | null, data: AmbassadorApplicationData) {
    const payload = {
      user_id: userId,
      full_name: data.fullName,
      email: data.email.toLowerCase(),
      whatsapp_number: data.whatsappNumber,
      country: data.country,
      city: data.city,
      age_range: data.ageRange,
      instagram_handle: data.instagramHandle || null,
      tiktok_handle: data.tiktokHandle || null,
      strongest_platform: data.strongestPlatform,
      follower_range: data.followerRange,
      content_niche: data.contentNiche,
      audience_summary: data.audienceSummary,
      best_content_link_1: data.bestContentLink1,
      best_content_link_2: data.bestContentLink2,
      why_join: data.whyJoin,
      how_would_you_share_lrnsy: data.howWouldYouShareLrnsy,
      available_for_zoom: data.availableForZoom,
      comfortable_with_kpis: data.comfortableWithKpis,
      preferred_payout_method: data.preferredPayoutMethod,
      status: "pending",
    };

    const { error } = await (supabase as any).from("ambassador_applications").insert(payload);

    if (error) throw error;
    return { success: true };
  }
}

export const ambassadorApplicationService = new AmbassadorApplicationService();
